import {connect} from 'react-redux';
import {TimespanCategoriesState} from '@pluto/timespan-categories';
import {TimespanCategory} from '@pluto/rest';

import {
    RemoveQCReportMarkerAction,
    removeQCReportMarkerAction,
    UpdateQCReportMarkerAction,
    updateQCReportMarkerAction,
} from 'VideoAudioQC/Timeline/QCReport/Redux/QCReportActions';
import {NoteType, QcJobStatuses} from '@pluto/@types';
import {updateQcJobReportStatusAction} from '@pluto/qc-reports/Redux/QCReportsActions';
import QCReportContainer from './QCReportContainer';
import {TimelineState} from '../../Timeline/Redux/TimelineReducer';
import {toggleSelectedMarkerAction} from '../../Timeline/Redux/TimelineActions';
import {QCReportMarker} from '../../Timeline/TimelineTypes';
import {QcJobStatusIndicatorState, QcJobStatusIndicatorStateItem} from '../../../QCTools/JobStatusIndicator/JobStatusIndicatorTypes';

export interface State {
    timeline: {
        selectedMarker: TimelineState;
        qcReport: {
            markers: QCReportMarker[];
            rowId: string;
        }
    },
    qcTools: {
        timespanCategories: TimespanCategoriesState,
        statusIndicators: QcJobStatusIndicatorState,
    },
}

export interface StateProps {
    identifier: string;
    markers: QCReportMarker[];
    selectedRowId: string;
    selectedMarkerId: string;
    noteTypes: TimespanCategory[];
    status: QcJobStatuses;
}

export const getStatusByType = (statusIndicators: QcJobStatusIndicatorStateItem[], type: string) => {
    if (!statusIndicators || statusIndicators.length === 0)
        return null;
    
    return statusIndicators.find((status: QcJobStatusIndicatorStateItem) => status.type === type);
};

export const mapState = (state: State): StateProps => {
    const {
        timeline,
        qcTools,
    } = state;
    const {
        selectedMarker,
        qcReport,
    } = timeline;
    const {
        timespanCategories,
        statusIndicators,
    } = qcTools;
    const noteTypes = timespanCategories.media;
    const visualQC = getStatusByType(statusIndicators.statusIndicators, NoteType.media);
    const status = visualQC ? visualQC.status : QcJobStatuses.Pending;
    
    return {
        status,
        identifier: qcReport.rowId,
        selectedMarkerId: selectedMarker.selectedMarkerId,
        selectedRowId: selectedMarker.selectedRowId,
        markers: qcReport.markers,
        noteTypes,
    };
};

export const mapDispatch = {
    updateQcJobReportStatus: updateQcJobReportStatusAction,
    toggleSelectedMarker: toggleSelectedMarkerAction,
    removeQCReportMarker: removeQCReportMarkerAction as RemoveQCReportMarkerAction,
    updateQCReportMarker: updateQCReportMarkerAction as UpdateQCReportMarkerAction,
};

export default connect(mapState, mapDispatch)(QCReportContainer);
